module.exports = __webpack_public_path__ + "img/logo.f428935b.png";